import { createActionGroup, props } from '@ngrx/store';

import { OrdAllocateI } from '../../api/ord-allocate/ord-allocate.result.int';
import { spxCreateApiActions } from '@softpak/components/spx-redux';

export const OrdDeAllocateMultipleActions = createActionGroup({
  source: 'OrdDeAllocateMultiple',
  events: {
    ...spxCreateApiActions<void, OrdAllocateI>(),
    Load: props<{ skipRefresh?: boolean; }>(),
  },
});
